import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import './Dialog.scss';
import { Modal } from '../modal/Modal';
export const Dialog = (props) => {
    const overlayRef = useRef(null);
    const dialogRef = useRef(null);
    const handleOverlayClick = (e) => {
        if (overlayRef.current === e.target) {
            props.onOverlayClick?.(e);
        }
    };
    const handleKeyDown = (e) => {
        if (e.keyCode === 27) {
            // Esc
            props.onEscKeyDown?.(e);
        }
    };
    useEffect(() => {
        dialogRef.current && dialogRef.current.focus();
    }, []);
    const className = props.onOverlayClick ? ' sg-dialog-clickable' : '';
    return (_jsx(Modal, { isModal: true, children: _jsx("div", { className: 'sg-dialog' + className, ref: overlayRef, onMouseDownCapture: props.onOverlayClick && handleOverlayClick, "data-test-id": props.testId ? `${props.testId}-overlay` : undefined, children: _jsx("div", { className: 'sg-dialog--body', ref: dialogRef, tabIndex: 0, style: {
                    width: props.width,
                    height: props.height,
                }, onKeyDown: props.onEscKeyDown && handleKeyDown, "data-test-id": props.testId, children: props.children }) }) }));
};
//# sourceMappingURL=Dialog.js.map